export default "__VITE_ASSET__B8Li1eOa__"